/* istanbul ignore file */
export enum MOBILE_CONFIGURATION {
    /**
     * @value Access video galleries
     * @description Text used to describe what the "Videos" mobile feature is.
     */
    ACCESS_VIDEO_GALLERIES = 'MOBILE.ACCESS_VIDEO_GALLERIES',
    /**
     * @value Add a configuration URL
     * @description Placeholder of mandatory text field
     */
    ADD_CONFIGURATION_URL = 'MOBILE.CONFIGURATION_ADD_CONFIGURATION_URL',
    /**
     * @value All fields must be completed.
     * @description Error text displayed when a user have not completed all required fields
     */
    ALL_FIELDS_COMPLETED = 'MOBILE.CONFIGURATION_ALL_FIELDS_COMPLETED',
    /**
     * @value App directory
     * @description App directory
     */
    APP_DIRECTORY = 'MOBILE_CONFIGURATION.APP_DIRECTORY',
    /**
     * @value Access directory entries
     * @description App directory description
     */
    APP_DIRECTORY_NAME_DESCRIPTION = 'MOBILE.CONFIGURATION_APP_DIRECTORY_NAME_DESCRIPTION',
    /**
     * @value Mobile app logo
     * @description Toolbar label that appears when the client upload a logo
     */
    APP_LOGO_EDITING_LABEL = 'MOBILE.CONFIGURATION_APP_LOGO_EDITING_LABEL',
    /**
     * @value Upload a .png file. Max-width must be 480 px, height must be 96 px. File must weight less than 300ko.
     * @description Helper text for the uploader
     */
    APP_LOGO_HELPER = 'MOBILE.CONFIGURATION_APP_LOGO_HELPER',
    /**
     * @value Add an app logo
     * @description Label of the uploader
     */
    APP_LOGO_LABEL = 'MOBILE.CONFIGURATION_APP_LOGO_LABEL',
    /**
     * @value Associated app
     */
    ASSOCIATED_BRANDED_APP = 'MOBILE.CONFIGURATION_ASSOCIATED_BRANDED_APP',
    /**
     * @value If branded apps are available, choose the app that can use this configuration
     */
    ASSOCIATED_BRANDED_APP_HELPER = 'MOBILE.CONFIGURATION_ASSOCIATED_BRANDED_APP_HELPER',
    /**
     * @value Use the primary color as navigation background
     * @description Content link to the background switch
     */
    BACKGROUND_SWITCH_CONTENT = 'MOBILE.CONFIGURATION_BACKGROUND_SWITCH_CONTENT',
    /**
     * @value Select a service that will be available for all community member
     * @description Description of the mandatory text field appear when select Chat feature
     */
    CHAT_CONFIGURE_DESCRIPTION = 'MOBILE.CONFIGURATION_CHAT_CONFIGURE_DESCRIPTION',
    /**
     * @value Engage users with direct messaging
     * @description Chat description
     */
    CHAT_DESCRIPTION = 'MOBILE.CONFIGURATION_CHAT_DESCRIPTION',
    /**
     * @value The color value has to respect the hexadecimal format: #xxxxxx
     * @description Error message appear when color theme is not in hexadecimal format
     */
    COLOR_THEME_ERROR_HELPER = 'MOBILE.CONFIGURATION_COLOR_THEME_ERROR_HELPER',
    /**
     * @value The primary color is used for the navigation bar and tab bar
     * @description Helper of the color theme selector
     */
    COLOR_THEME_HELPER = 'MOBILE.CONFIGURATION_COLOR_THEME_HELPER',
    /**
     * @value Primary color
     * @description Label of the section where we choose the background color of the mobile application configuration.
     */
    COLOR_THEME_LABEL = 'MOBILE.CONFIGURATION_COLOR_THEME_LABEL',
    /**
     * @value Hexadecimal code
     * @description Placeholder of the color theme text field
     */
    COLOR_THEME_PLACEHOLDER = 'MOBILE.CONFIGURATION_COLOR_THEME_PLACEHOLDER',
    /**
     * @value Color theme
     * @description Title of the color theme section
     */
    COLOR_THEME_TITLE = 'MOBILE.CONFIGURATION_COLOR_THEME_TITLE',
    /**
     * @value The application background is already white. You must choose a different color.
     * @description Error message displayed when the mobile configuration branding color is too white.
     */
    COLOR_THEME_WHITE_ERROR_HELPER = 'MOBILE.CONFIGURATION_COLOR_THEME_WHITE_ERROR_HELPER',
    /**
     * @value Communities & search results
     */
    COMMUNITIES_AND_SEARCH_RESULTS = 'MOBILE.CONFIGURATION_COMMUNITIES_AND_SEARCH_RESULTS',
    /**
     * @value Gather users around a topic and engage social interactions with them
     * @description Communities description
     */
    COMMUNITIES_DESCRIPTION = 'MOBILE.CONFIGURATION_COMMUNITIES_DESCRIPTION',
    /**
     * @value Configuration visibility
     * @description Title of the section to configure the visibility of the mobile configuration.
     */
    CONFIGURATION_VISIBILITY = 'MOBILE.CONFIGURATION_CONFIGURATION_VISIBILITY',
    /**
     * @value You have not finished your app configuration. It will be deleted permanently. This action can not be reverted.
     * @description Description of the warning dialog when clicking on the cancel button
     */
    CONFIRM_DIALOG_DESCRIPTION = 'MOBILE.CONFIGURATION_CONFIRM_DIALOG_DESCRIPTION',
    /**
     * @value Discard configuration ?
     * @description Title of the warning dialog when clicking on the cancel button
     */
    CONFIRM_DIALOG_TITLE = 'MOBILE.CONFIGURATION_CONFIRM_DIALOG_TITLE',
    /**
     * @value Stream content from platform
     * @description Content stream description
     */
    CONTENT_STREAM_DESCRIPTION = 'MOBILE.CONFIGURATION_CONTENT_STREAM_DESCRIPTION',
    /**
     * @value New Configuration
     * @description Text displayed on a button allowing the user to starting to create a configuration.
     */
    CREATE = 'MOBILE.CONFIGURATION_CREATE',
    /**
     * @value The modifications will be visible in 24 hours, or if the user logs out and logs back in.
     */
    DELAY_CONFIRMATION = 'MOBILE.CONFIGURATION_DELAY_CONFIRMATION',
    /**
     * @value <strong>%NB% Configurations</strong> will be permanently deleted.
     * @description Message shown in the confirmation dialog when multiple configurations are being deleted.
     */
    DELETE_NB_DESCRIPTION = 'MOBILE.CONFIGURATION_DELETE_NB_DESCRIPTION',
    /**
     * @value Delete %NB% Configurations
     * @description Messages shown on the dialog's title when trying to delete multiple configurations with the number showing.
     */
    DELETE_NB_TITLE = 'MOBILE.CONFIGURATION_DELETE_NB_TITLE',
    /**
     * @value <strong>1 Configuration</strong> will be permanently deleted.
     * @description Message shown in a confirmation dialog when trying to delete a configuration.
     */
    DELETE_ONE_DESCRIPTION = 'MOBILE.CONFIGURATION_DELETE_ONE_DESCRIPTION',
    /**
     * @value Delete configuration
     * @description Messages shown on the dialog's title when trying to delete one configuration.
     */
    DELETE_ONE_TITLE = 'MOBILE.CONFIGURATION_DELETE_ONE_TITLE',
    /**
     * @value Configuration(s) successfully deleted.
     * @description Text displayed on the success notification when a configuration is deleted.
     */
    DELETE_SUCCESS_NOTIFICATION = 'MOBILE.CONFIGURATION_DELETE_SUCCESS_NOTIFICATION',
    /**
     * @value Drag and drop items to change their position in the app.
     * @description Subtitle of the section
     */
    DESIGNER_SUBTITLE = 'MOBILE.CONFIGURATION_DESIGNER_SUBTITLE',
    /**
     * @value Designer
     * @description Title of the organization section
     */
    DESIGNER_TITLE = 'MOBILE.CONFIGURATION_DESIGNER_TITLE',
    /**
     * @value Drop feature here
     * @description Helper when drop zone is empty
     */
    DROP_FEATURE_HERE = 'MOBILE.CONFIGURATION_DROP_FEATURE_HERE',
    /**
     * @value Configuration successfully duplicated
     * @description Success message appear when a configuration is duplicated
     */
    DUPLICATE_SUCCESS_NOTIFICATION = 'MOBILE.CONFIGURATION_DUPLICATE_SUCCESS_NOTIFICATION',
    /**
     * @value All unsaved changes will be lost. Are you sure you want to discard them?
     * @description Description of the warning dialog appear when click on cancel button in edition
     */
    EDIT_CONFIRM_DIALOG_DESCRIPTION = 'MOBILE.CONFIGURATION_EDIT_CONFIRM_DIALOG_DESCRIPTION',
    /**
     * @value Unsaved changes
     * @description Title of the warning dialog appear when click on cancel in edition
     */
    EDIT_CONFIRM_DIALOG_TITLE = 'MOBILE.CONFIGURATION_EDIT_CONFIRM_DIALOG_TITLE',
    /**
     * @value When the users click the Menu tab, they see additional features of the application in a horizontal list.
     * @description Description of the second module
     */
    EXPLORE_MODULES_CAPTION = 'MOBILE.CONFIGURATION_EXPLORE_MODULES_CAPTION',
    /**
     * @value Menu page header
     * @description Title of the second module
     */
    EXPLORE_MODULES_TITLE = 'MOBILE.CONFIGURATION_EXPLORE_MODULES_TITLE',
    /**
     * @value At least one features must be added to the tab bar
     * @description Alert message display when explore page header is empty
     */
    EXPLORE_PAGE_HEADER_ALERT = 'MOBILE.CONFIGURATION_EXPLORE_PAGE_HEADER_ALERT',
    /**
     * @value To enhance user experience we recommend you to prioritize location of features within the tab bar. The tab visibility helps access functions more easily.
     * @description Warning message
     */
    EXPLORE_PAGE_HEADER_WARNING = 'MOBILE.CONFIGURATION_EXPLORE_PAGE_HEADER_WARNING',
    /**
     * @value Only four tabs are available on the tab bar. Additional features must be added to the Explore page.
     * @description Alert message
     */
    EXPLORE_TAB_BAR_ALERT = 'MOBILE.CONFIGURATION_EXPLORE_TAB_BAR_ALERT',
    /**
     * @value Put features available on the mobile app by activating them for the list:
     * @description Features description
     */
    FEATURES_DESCRIPTION = 'MOBILE.CONFIGURATION_FEATURES_DESCRIPTION',
    /**
     * @value Select at least one feature.
     * @description Error message display when none features are selected
     */
    FEATURES_EMPTY_ERROR = 'MOBILE.CONFIGURATION_FEATURES_EMPTY_ERROR_MESSAGE',
    /**
     * @value Navigation can’t be the only feature selected. Select another feature.
     * @description Message display if only Navigation feature is selected
     */
    FEATURES_ONLY_NAVIGATION_ERROR = 'MOBILE.CONFIGURATION_FEATURES_ONLY_NAVIGATION_SELECTED',
    /**
     * @value Mobile app features
     * @description Features title
     */
    FEATURES_TITLE = 'MOBILE.CONFIGURATION_FEATURES_TITLE',
    /**
     * @value Access and submit forms, and view submitted responses
     * @description Description of the purpose of the forms feature
     */
    FORMS_DESCRIPTION = 'MOBILE.FORMS_DESCRIPTION',
    /**
     * @value %NB% groups sorted by date added
     * @description Text displayed in the configuration groups modal when the user have selected more than one group.
     */
    GROUPS_ADDED_MANY = 'MOBILE.CONFIGURATION_GROUPS_ADDED_MANY',
    /**
     * @value 1 group sorted by date added
     * @description Text displayed in the configuration groups modal when the user have selected one group.
     */
    GROUPS_ADDED_ONE = 'MOBILE.CONFIGURATION_GROUPS_ADDED_ONE',
    /**
     * @value Define the groups of users for which the app configuration is available.
     * @description Description of the groups configuration modal.
     */
    GROUPS_DESCRIPTION = 'MOBILE.CONFIGURATION_GROUPS_DESCRIPTION',
    /**
     * @value Remove group
     * @description Text used as label for removing a group from a list of groups on the mobile configuration wizard.
     */
    GROUPS_REMOVE = 'MOBILE.CONFIGURATION_GROUPS_REMOVE',
    /**
     * @value A group is required
     */
    GROUP_REQUIRED = 'SERVER_ERROR_ROLE_USER_OR_FEED_REQUIRED',
    /**
     * @value Configurable home screen. Always located as the first tab in the tab bar.
     * @description It's the description of the "Home" feature in the mobile app configuration dialog in the back-office of the application.
     */
    HOME_DESCRIPTION = 'ADMIN.MOBILE.HOME.FEATURE_DESCRIPTION',
    /**
     * @value There are no sections
     * @description Message indicating the user there are no section (he will need to select one)
     */
    HOME_PAGE_ABSENCE = 'MOBILE.HOME_PAGE_ABSENCE',
    /**
     * @value Add section
     * @description Label on a button to add one or multiple section
     */
    HOME_PAGE_ADD = 'MOBILE.HOME_PAGE_ADD',
    /**
     * @value Add, configure and re-order sections
     * @description Description for a configuration menu
     */
    HOME_PAGE_ADD_MESSAGE = 'MOBILE.HOME_PAGE_ADD_MESSAGE',
    /**
     * @value Add at least one home section
     * @description Error message for the home page section.
     */
    HOME_PAGE_ERROR = 'MOBILE.HOME_PAGE_ERROR',
    /**
     * @value The maximum number of entries has been reached.
     */
    HOME_PAGE_MAX_ENTRIES_REACHED = 'MOBILE.HOME_PAGE_MAX_ENTRIES_REACHED',
    /**
     * @value Customizable alert message, sourced from existing content
     */
    HOME_PAGE_SECTION_ALERT_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_ALERT_DESCRIPTION',
    /**
     * @value The alert section displays existing content from a specific content type, displaying only the content title. It inherits visibility and publication dates from the content.
     */
    HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE',
    /**
     * @value The alert section displays the content title from a selected content type, and inherits its visibility and publication dates.
     */
    HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_BODY = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_BODY',
    /**
     * @value Groups to notify
     */
    HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_DOC_LINK_1 = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_DOC_LINK_1',
    /**
     * @value Contextual action menu
     */
    HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_DOC_LINK_2 = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_DOC_LINK_2',
    /**
     * @value Enable the %DOC_LINK_1% setting in the content designer.
     * @description %DOC_LINK_1% is a reference to "Groups to notify" which will be a link to the documentation.
     */
    HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_INSTRUCTIONS_1 = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_INSTRUCTIONS_1',
    /**
     * @value Go to the %DOC_LINK_2% > Distribute, and schedule your broadcast.
     * @description %DOC_LINK_2% will be a link to the "Contextual Actions" page from the documentation.
     */
    HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_INSTRUCTIONS_2 = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_INSTRUCTIONS_2',
    /**
     * @value To notify users:
     * @description This is the label coming before an ordered list of tasks.
     */
    HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_LABEL = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_MESSAGE_NOTIFY_USERS_LABEL',
    /**
     * @value Configure Alert section
     */
    HOME_PAGE_SECTION_ALERT_EDIT_TITLE = 'MOBILE.HOME_PAGE_SECTION_ALERT_EDIT_TITLE',
    /**
     * @value Alert
     * @description Title of a section that can provide information on a current alert
     */
    HOME_PAGE_SECTION_ALERT_TITLE = 'MOBILE.HOME_PAGE_SECTION_ALERT_TITLE',
    /**
     * @value Use hexadecimal code. If empty, the primary color defined in the mobile configuration is used.
     * @description Helper for color field
     */
    HOME_PAGE_SECTION_CALL_TO_ACTION_COLOR_FIELD_HELPER = 'MOBILE.HOME_PAGE_SECTION_CALL_TO_ACTION_COLOR_FIELD_HELPER',
    /**
     * @value Customizable message with a title, description, URL, and image
     */
    HOME_PAGE_SECTION_CALL_TO_ACTION_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_CALL_TO_ACTION_DESCRIPTION',
    /**
     * @value The Call to action section displays a visually engaging message.
     */
    HOME_PAGE_SECTION_CALL_TO_ACTION_EDIT_MESSAGE = 'MOBILE.HOME_PAGE_SECTION_CALL_TO_ACTION_EDIT_MESSAGE',
    /**
     * @value Configure Call to action section
     */
    HOME_PAGE_SECTION_CALL_TO_ACTION_EDIT_TITLE = 'MOBILE.HOME_PAGE_SECTION_CALL_TO_ACTION_EDIT_TITLE',
    /**
     * @value Please ensure that the image adheres to the specified format.
     * @description Error message for an image picker
     */
    HOME_PAGE_SECTION_CALL_TO_ACTION_IMAGE_PICKER_ERROR = 'MOBILE.HOME_PAGE_SECTION_CALL_TO_ACTION_IMAGE_PICKER_ERROR',
    /**
     * @value Upload a .png file with square ratio not exceeding 512x512 pixels in size and 500 KB in weight.
     * @description Helper on an image uploader
     */
    HOME_PAGE_SECTION_CALL_TO_ACTION_IMAGE_PICKER_HELPER = 'MOBILE.HOME_PAGE_SECTION_CALL_TO_ACTION_IMAGE_PICKER_HELPER',
    /**
     * @value Call to action
     * @description Asking the user to perform an action
     */
    HOME_PAGE_SECTION_CALL_TO_ACTION_TITLE = 'MOBILE.HOME_PAGE_SECTION_CALL_TO_ACTION_TITLE',
    /**
     * @value Display a selection of communities.
     */
    HOME_PAGE_SECTION_COMMUNITIES_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_COMMUNITIES_DESCRIPTION',
    /**
     * @value The Communities section displays a selection of communities.
     */
    HOME_PAGE_SECTION_COMMUNITIES_EDIT_MESSAGE = 'MOBILE.HOME_PAGE_SECTION_COMMUNITIES_EDIT_MESSAGE',
    /**
     * @value Configure Communities section
     */
    HOME_PAGE_SECTION_COMMUNITIES_EDIT_TITLE = 'MOBILE.HOME_PAGE_SECTION_COMMUNITIES_EDIT_TITLE',
    /**
     * @value Communities
     * @description Title of a section that displays a list of selected communities
     */
    HOME_PAGE_SECTION_COMMUNITIES_TITLE = 'MOBILE.HOME_PAGE_SECTION_COMMUNITIES_TITLE',
    /**
     * @value Content stream selected from your platform
     */
    HOME_PAGE_SECTION_CONTENT_STREAM_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_CONTENT_STREAM_DESCRIPTION',
    /**
     * @value The content stream section displays an existing stream. It inherits its name, visibility, view mode, and number of items. A link gives access to the content stream details.
     */
    HOME_PAGE_SECTION_CONTENT_STREAM_EDIT_MESSAGE = 'MOBILE.HOME_PAGE_SECTION_CONTENT_STREAM_EDIT_MESSAGE',
    /**
     * @value Configure Content stream section
     */
    HOME_PAGE_SECTION_CONTENT_STREAM_EDIT_TITLE = 'MOBILE.HOME_PAGE_SECTION_CONTENT_STREAM_EDIT_TITLE',
    /**
     * @value Pick a content stream from your platform.
     * @description Descriptive text in the mobile configuration, to tell the administrator that he must chose a content stream for the feature to be configured.
     */
    HOME_PAGE_SECTION_CONTENT_STREAM_PICK = 'MOBILE.HOME_PAGE_SECTION_CONTENT_STREAM_PICK',
    /**
     * @value Latest items from the employee's personal feed
     * @description "feed" like a news feed in social media.
     */
    HOME_PAGE_SECTION_FEED_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_FEED_DESCRIPTION',
    /**
     * @value Personal feed
     * @description "feed" like in news feed from social media for instance.
     */
    HOME_PAGE_SECTION_FEED_TITLE = 'MOBILE.HOME_PAGE_SECTION_FEED_TITLE',
    /**
     * @value Employee welcome message
     */
    HOME_PAGE_SECTION_GREETINGS_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_GREETINGS_DESCRIPTION',
    /**
     * @value Welcome message
     */
    HOME_PAGE_SECTION_GREETINGS_TITLE = 'MOBILE.HOME_PAGE_SECTION_GREETINGS_TITLE',
    /**
     * @value Ongoing employee training courses and learning paths.
     */
    HOME_PAGE_SECTION_LEARNING_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_LEARNING_DESCRIPTION',
    /**
     * @value Current training
     */
    HOME_PAGE_SECTION_LEARNING_TITLE = 'WIDGET_TYPE_LEARNING-TRAINING-COURSES-IN-PROGRESS',
    /**
     * @value Recommended & mandatory employee training courses and learning paths.
     */
    HOME_PAGE_SECTION_LEARNING_TO_DO_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_LEARNING_TO_DO_DESCRIPTION',
    /**
     * @value Training to do
     */
    HOME_PAGE_SECTION_LEARNING_TO_DO_TITLE = 'MOBILE.HOME_PAGE_SECTION_LEARNING_TO_DO_TITLE',
    /**
     * @value Display a selected micro-app.
     * @description Description of a section that displays a micro-app
     */
    HOME_PAGE_SECTION_MICRO_APP_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_MICRO_APP_DESCRIPTION',
    /**
     * @value The Micro-app section inherits selected Micro-app's name and visibility.
     */
    HOME_PAGE_SECTION_MICRO_APP_EDIT_MESSAGE = 'MOBILE.HOME_PAGE_SECTION_MICRO_APP_EDIT_MESSAGE',
    /**
     * @value Configure Micro-app section
     */
    HOME_PAGE_SECTION_MICRO_APP_EDIT_TITLE = 'MOBILE.HOME_PAGE_SECTION_MICRO_APP_EDIT_TITLE',
    /**
     * @value Pick a Micro-app from your platform.
     * @description Descriptive text in the mobile configuration, to tell the administrator that he must chose a Micro-app for the feature to be configured.
     */
    HOME_PAGE_SECTION_MICRO_APP_PICK = 'MOBILE.HOME_PAGE_SECTION_MICRO_APP_PICK',
    /**
     * @value Micro-app
     * @description Title of a section that displays a micro-app
     */
    HOME_PAGE_SECTION_MICRO_APP_TITLE = 'MOBILE.HOME_PAGE_SECTION_MICRO_APP_TITLE',
    /**
     * @value Employee current or next shifts.
     */
    HOME_PAGE_SECTION_SHIFTS_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_SHIFTS_DESCRIPTION',
    /**
     * @value Customizable directory entries and feature shortcuts
     */
    HOME_PAGE_SECTION_SHORTCUT_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_DESCRIPTION',
    /**
     * @value Use features and a directory
     * @description The "directories" are the same ones defined in the back-office and for the web version: they are catalogs of links to give users shortcuts to resources.
     */
    HOME_PAGE_SECTION_SHORTCUT_DIRECTORY = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_DIRECTORY',
    /**
     * @value The shortcuts section allows users to display shortcuts from the Shortcuts managed in Beekeeper.
     */
    HOME_PAGE_SECTION_SHORTCUT_EDIT_BEEKEEPER_MESSAGE = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_EDIT_BEEKEEPER_MESSAGE',
    /**
     * @value The shortcuts section allows users to create shortcuts from %DOC_LINK% and from an optional directory.
     * @description %DOC_LINK% will be making reference to "features"
     */
    HOME_PAGE_SECTION_SHORTCUT_EDIT_MESSAGE = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_EDIT_MESSAGE',
    /**
     * @value Configure Shortcuts section
     */
    HOME_PAGE_SECTION_SHORTCUT_EDIT_TITLE = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_EDIT_TITLE',
    /**
     * @value Use only features
     * @description The "features" are actual "mobile feature" (the ones that the mobile administrator can enable or disable in the mobile configuration).
     * In that section of the new "mobile homepage", the end user will be able to select up to 3 mobile features to add  as shortcuts in that section of his mobile homepage.
     * The user can basically customise his mobile homepage with shortcuts to other mobile features like the Personal Feed or the Communities.
     */
    HOME_PAGE_SECTION_SHORTCUT_FEATURE = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_FEATURE',
    /**
     * @value Pick a directory from your platform.
     */
    HOME_PAGE_SECTION_SHORTCUT_PICK = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_PICK',
    /**
     * @value Display
     */
    HOME_PAGE_SECTION_SHORTCUT_SETTINGS_TITLE = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_SETTINGS_TITLE',
    /**
     * @value First %NB% shortcuts will be displayed
     */
    HOME_PAGE_SECTION_SHORTCUT_STYLE_HELPER = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_STYLE_HELPER',
    /**
     * @value Display style
     */
    HOME_PAGE_SECTION_SHORTCUT_STYLE_TITLE = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_STYLE_TITLE',
    /**
     * @value Shortcuts
     * @description "Shortcut" like a link for a content on the web.
     */
    HOME_PAGE_SECTION_SHORTCUT_TITLE = 'MOBILE.HOME_PAGE_SECTION_SHORTCUT_TITLE',
    /**
     * @value Displays a list of personal and team tasks.
     */
    HOME_PAGE_SECTION_TASKS_DESCRIPTION = 'MOBILE.HOME_PAGE_SECTION_TASKS_DESCRIPTION',
    /**
     * @value Sections
     * @description "Sections" as different possibles parts.
     */
    HOME_PAGE_SECTION_TITLE = 'MOBILE.HOME_PAGE_SECTION_TITLE',
    /**
     * @value Invalid name
     * @description Text displayed to the user when a text field is not properly filled.
     */
    INVALID_NAME = 'MOBILE.CONFIGURATION_INVALID_NAME',
    /**
     * @value Access catalog and learning content
     */
    LEARNING_DESCRIPTION = 'ADMIN.MOBILE.LEARNING.FEATURE_DESCRIPTION',
    /**
     * @value To ease the use of navigation and optimize the layout, limit the number of characters of each field.
     * @description Message displayed to the user to encourage him to write short words / sentences.
     */
    LIMIT_CHARACTER_NUMBER = 'MOBILE.CONFIGURATION_LIMIT_CHARACTER_NUMBER',
    /**
     * @value The tab bar is a permanent navigation item that allows users to access a feature in one click. For optimal use, you should add the main feature of the app here. You can only have a maximum of 4 features.
     * @description Explication of the first module
     */
    MAIN_MODULES_CAPTION = 'MOBILE.CONFIGURATION_MAIN_MODULES_CAPTION',
    /**
     * @value Tab bar
     * @description Title of the first module
     */
    MAIN_MODULES_TITLE = 'MOBILE.CONFIGURATION_MAIN_MODULES_TITLE',
    /**
     * @value Display communities from
     */
    MOBILE_COMMUNITY_INSTANCES_SELECT = 'ADMIN.MOBILE_COMMUNITY_INSTANCES_SELECT',
    /**
     * @value The mobile application displays communities from the selected sites. If no site is selected, the platform default site is used as a fallback.
     */
    MOBILE_COMMUNITY_INSTANCES_SELECT_HELPER = 'ADMIN.MOBILE_COMMUNITY_INSTANCES_SELECT_HELPER',
    /**
     * @value Display search results from
     */
    MOBILE_SEARCH_INSTANCES_SELECT = 'ADMIN.MOBILE_SEARCH_INSTANCES_SELECT',
    /**
     * @value Select which sites are accessible through the mobile application search. If no site is selected, the sites chosen for communities on mobile are used.
     * If no site is selected for communities, the mobile application searches all sites on the platform and provides filtering by site.
     */
    MOBILE_SEARCH_INSTANCES_SELECT_HELPER = 'ADMIN.MOBILE_SEARCH_INSTANCES_SELECT_HELPER',
    /**
     * @value Content stream
     */
    MOBILE_SETTINGS_CONTENT_STREAMS = 'ADMIN.NAV.MOBILE_SETTINGS_CONTENT_STREAMS',
    /**
     * @value New app configuration
     * @description Title of the creation modal when clicking on button
     */
    MODAL_CREATE_TITLE = 'MOBILE.CONFIGURATION_MODAL_CREATE_TITLE',
    /**
     * @value Edit app configuration
     * @description Title of the edit modal when clicking on the edit configuration button
     */
    MODAL_EDIT_TITLE = 'MOBILE.CONFIGURATION_MODAL_EDIT_TITLE',
    /**
     * @value Access a hierarchy of content
     * @description Navigation description
     */
    NAVIGATION_DESCRIPTION = 'MOBILE.CONFIGURATION_NAVIGATION_DESCRIPTION',
    /**
     * @value Content navigation allow user to navigate across platform content. Navigation can only be displayed on the explore page.
     * @description Description of the third module
     */
    NAVIGATION_MODULE_SUBTITLE = 'MOBILE.CONFIGURATION_NAVIGATION_MODULE_SUBTITLE',
    /**
     * @value Navigation on Explore page
     * @description Title of the third module
     */
    NAVIGATION_MODULE_TITLE = 'MOBILE.CONFIGURATION_NAVIGATION_MODULE_TITLE',
    /**
     * @value Send notifications from
     * @description Label of the modal notifications pickerfield.
     */
    NOTIFICATIONS_LABEL = 'MOBILE.CONFIGURATION_NOTIFICATIONS_LABEL',
    /**
     * @value Select the sites permitted to send notifications via this app configuration. Leaving this blank will allow all sites to send notifications.
     * @description Label helper of the notifications modal pickerfield.
     */
    NOTIFICATIONS_LABEL_HELPER = 'MOBILE.CONFIGURATION_NOTIFICATIONS_LABEL_HELPER',
    /**
     * @value Select sites...
     * @description Placeholder of the notifications modal pickerfield.
     */
    NOTIFICATIONS_SELECT_SITES = 'MOBILE.CONFIGURATION_NOTIFICATIONS_SELECT_SITES',
    /**
     * @value Only https is supported. Deeplinks are not supported.
     * @description Message under a text field to inform the user to only write https web url.
     */
    ONLY_HTTPS_MESSAGE = 'MOBILE.ONLY_HTTPS_MESSAGE',
    /**
     * @value People
     */
    PEOPLE = 'BOOKMARKED_MS_APPS_PEOPLE',
    /**
     * @value List users from the organization and present their profile
     * @description People description
     */
    PEOPLE_DESCRIPTION = 'MOBILE.CONFIGURATION_PEOPLE_DESCRIPTION',
    /**
     * @value Recent updates from user’s subscriptions.
     * @description A desrciption explaining what is the Feed Feature (a Facebook-like Feed)
     */
    PERSONAL_FEED_DESCRIPTION = 'MOBILE_CONFIGURATION.PERSONAL_FEED_DESCRIPTION',
    /**
     * @value Priority is applied when more than one app configuration is available to a user
     * @description Helper of the helper selector
     */
    PRIORITY_HELPER = 'MOBILE.CONFIGURATION_PRIORITY_HELPER',
    /**
     * @value Reset to default names
     * @description Text displayed on a button to trigger an action to reset default name values.
     */
    RESET_DEFAULT_NAMES = 'MOBILE.CONFIGURATION_RESET_DEFAULT_NAMES',
    /**
     * @value Configuration successfully saved
     * @description Success message appear when a configuration is created or updated
     */
    SAVE_SUCCESS_NOTIFICATION = 'MOBILE.CONFIGURATION_SAVE_SUCCESS_NOTIFICATION',
    /**
     * @value Source site
     */
    SELECT_SOURCE_SITE_LABEL = 'ADMIN.CUSTOMER.STREAMS.INSTANCE_LABEL',
    /**
     * @value Shifts
     * @description The name of the feature allowing to add shifts in the mobile configuration.
     */
    SHIFTS = 'MOBILE.SHIFTS',
    /**
     * @value Create and manage shift schedules, assign shifts to users, set time blocks and roles, and track attendance
     * @description Description of the purpose of the shifts feature
     */
    SHIFTS_DESCRIPTION = 'MOBILE.SHIFTS_DESCRIPTION',
    /**
     * @value Enable to share content externally
     * @description Social advocacy description
     */
    SOCIAL_ADVOCACY_DESCRIPTION = 'MOBILE.CONFIGURATION_SOCIAL_ADVOCACY_DESCRIPTION',
    /**
     * @value Specify sites for this configuration.
     */
    SPECIFY_SITES_FOR_THIS_CONFIGURATION = 'MOBILE.CONFIGURATION_SPECIFY_SITES_FOR_THIS_CONFIGURATION',
    /**
     * @value Create, assign, and manage tasks with due dates and completion tracking
     * @description Description of the purpose of the tasks feature
     */
    TASKS_DESCRIPTION = 'MOBILE.TASKS_DESCRIPTION',
    /**
     * @value App configuration
     * @description Title of the mobile configuration administration
     */
    TITLE = 'MOBILE.CONFIGURATION_TITLE',
    /**
     * @value App configuration title
     * @description Placeholder of the title section
     */
    TITLE_PLACEHOLDER = 'MOBILE.CONFIGURATION_TITLE_PLACEHOLDER',
    /**
     * @value Use sites defined in general settings.
     */
    USE_SITES_DEFINED_IN_GENERAL_SETTINGS = 'MOBILE.CONFIGURATION_USE_SITES_DEFINED_IN_GENERAL_SETTINGS',
    /**
     * @value Web pages
     * @description The name of the feature allowing to add web pages in the mobile configuration.
     */
    WEB_PAGES = 'MOBILE.WEB_PAGES',
    /**
     * @value There are no web pages
     * @description Message to inform the user that there are no web pages
     */
    WEB_PAGE_ABSENCE = 'MOBILE.WEB_PAGE_ABSENCE',
    /**
     * @value Add web page
     * @description Title of the dialog in the mobile configuration, inviting an admin to enter an URL and pick an icon, to add a web page in the navigation of the mobile app.
     */
    WEB_PAGE_ADD = 'MOBILE.ADD_WEB_PAGE',
    /**
     * @value Add web pages, they will appear in the designer tab to translate and position in the app
     * @description Description of the purpose of the web page feature
     */
    WEB_PAGE_ADD_MESSAGE = 'MOBILE.WEB_PAGE_ADD_MESSAGE',
    /**
     * @value Create at least one web page
     * @description Message informing the user to create at least one web page
     */
    WEB_PAGE_CREATE_AT_LEAST_ONE = 'MOBILE.WEB_PAGE_CREATE_AT_LEAST_ONE',
    /**
     * @value Display web pages in dedicated screens, configure in configuration tab
     * @description Web page feature description
     */
    WEB_PAGE_DESCRIPTION = 'MOBILE.WEB_PAGE_DESCRIPTION',
}

export enum MOBILE_CONFIGURATION_GALLERIES {
    /**
     * @value Add gallery
     * @description Text used to label a button that allows the user to add a new video gallery.
     */
    ADD_GALLERY = 'MOBILE.ADD_GALLERY',
    /**
     * @value Some galleries are not available anymore
     * @description Text warning the user that some video galleries are no longer available.
     */
    GALLERIES_NO_LONGER_AVAILABLE = 'MOBILE.GALLERIES_NO_LONGER_AVAILABLE',
    /**
     * @value This gallery is not available anymore
     * @description Text warning the user that a video gallery is no longer available.
     */
    GALLERY_NO_LONGER_AVAILABLE = 'MOBILE.GALLERY_NO_LONGER_AVAILABLE',
    /**
     * @value No configuration required
     * @description Text displayed to inform the user that no special configuration is required for a particular feature.
     */
    NO_CONFIGURATION_REQUIRED = 'MOBILE.NO_CONFIGURATION_REQUIRED',
    /**
     * @value Pick at least one gallery that will be accessible with this app configuration
     * @description Text inviting the user to choose new video galleries to be displayed on the mobile application
     */
    NO_GALLERY_DESCRIPTION = 'MOBILE.NO_GALLERIES_DESCRIPTION',
    /**
     * @value There are no galleries
     * @description Text displayed to inform the user that no video gallery has been selected yet.
     */
    NO_GALLERY_TITLE = 'MOBILE.NO_GALLERIES_TITLE',
    /**
     * @value Pick gallery
     * @description Text used to label a button allowing our users to pick a video gallery.
     */
    PICK_GALLERY = 'MOBILE.PICK_GALLERY',
    /**
     * @value Pick at least one video gallery in the Configuration tab
     * @description Text that warns the user to choose at least one video gallery from the Configuration Tab before saving the changes.
     */
    PICK_GALLERY_DIALOG_ERROR = 'MOBILE.PICK_GALLERY_DIALOG_ERROR',
    /**
     * @value Pick at least one video gallery
     * @description Text that warns the user to choose at least one video gallery before saving the changes.
     */
    PICK_GALLERY_ERROR_MESSAGE = 'MOBILE.PICK_GALLERY_ERROR_MESSAGE',
    /**
     * @value Select a gallery
     * @description Text used as the title of a modal that allows the user to choose from several video galleries.
     */
    SELECT_A_GALLERY = 'MOBILE.SELECT_GALLERY',
}

export enum MOBILE_CONFIGURATION_SITES {
    /**
     * @value Add site
     */
    ADD_SITE = 'MOBILE.ADD_SITE',
    /**
     * @value Pick at least one site that will be accessible with this app configuration
     */
    NO_SITES_DESCRIPTION = 'MOBILE.NO_SITES_DESCRIPTION',
    /**
     * @value There are no sites
     */
    NO_SITES_TITLE = 'MOBILE.NO_SITES_TITLE',
    /**
     * @value Pick site
     */
    PICK_SITE = 'MOBILE.PICK_SITE',
    /**
     * @value Pick at least one site
     */
    PICK_SITE_ERROR_MESSAGE = 'MOBILE.PICK_SITE_ERROR_MESSAGE',
    SITES_NO_LONGER_AVAILABLE = 'MOBILE.SITES_NO_LONGER_AVAILABLE',
}
